import React from 'react';

export function FallbackLoader() {
  return <div className="d-sm-flx flx-jc-sm-c flx-ai-sm-c mt12-sm mb12-sm">LOADING...</div>;
}
